import { Grid, GridProps, List, ThemeIcon } from "@mantine/core";
import { IconMinus, IconPlus } from "@tabler/icons-react";

export interface ProsAndConsProps extends Omit<GridProps, "children"> {
    pros: string[];
    cons: string[];
}

export const ProsAndCons = ({ pros, cons, ...rest }: ProsAndConsProps) => {
    return (
        <Grid {...rest}>
            <Grid.Col xs={12} sm={6} md={4}>
                <List
                    spacing="sm"
                    icon={
                        <ThemeIcon color="green" size={24} radius="xl">
                            <IconPlus size="1em" />
                        </ThemeIcon>
                    }
                >
                    {(pros || []).map((pro, index) => (
                        <List.Item key={`${index}${pro}`}>
                            {pro}
                        </List.Item>
                    ))}
                </List>
            </Grid.Col>
            <Grid.Col xs={12} sm={6} md={4}>
                <List
                    spacing="sm"
                    icon={
                        <ThemeIcon color="red" size={24} radius="xl">
                            <IconMinus size="1em" />
                        </ThemeIcon>
                    }
                >
                    {(cons || []).map((con, index) => (
                        <List.Item key={`${index}${con}`}>
                            {con}
                        </List.Item>
                    ))}
                </List>
            </Grid.Col>
        </Grid>
    );
};
